import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import FilterListIcon from '@mui/icons-material/FilterList';

import Loading from '../../common/Loading';
import ProjectsFilterStatus from './ProjectsFilterStatus';
import ProjectsFilterManagerList from './ProjectsFilterManagerList';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function ProjectsFilter(props){
    //console.debug("RTS Break ProjectsFilter");

    const {setCurFilter, sessionCustomer} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [formDirty, setFormDirty] = useState(0); 

    const [status, setStatus] = useState(-1);
    const [manager, setManager] = useState();
    

    useEffect(() => {
        setStatus(props.filter.status);
        setManager(props.filter.manager);
        setIsLoading(false);
    }, [props]);
    

    function setFilter(){
        setFormDirty(0);
        setCurFilter({key:'ProjectsPage', filter:{customer:sessionCustomer.customer, manager:manager, status:status}});
        props.setFilterFx({customer:sessionCustomer.customer, manager:manager, status:status});
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
                <ProjectsFilterManagerList manager={manager} setManagerFx={setManager} setFormDirtyFx={setFormDirty} />
            </Grid>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center',sm:'left'}}}>
                <ProjectsFilterStatus status={status} setStatusFx={setStatus} setFormDirtyFx={setFormDirty} />
            </Grid>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center', sm:'left'}}}>
                <Button type="button" variant="contained" disabled={formDirty===1?false:true} onClick={setFilter}>
                    <FilterListIcon />
                    <Typography sx={{ml:1}}>Filter</Typography>
                </Button>
            </Grid>            
        </Grid>
    );
}
